module.exports = __webpack_public_path__ + "static/South_Stream-884955a836dc57d408d3a0efafcc1e44.png";